import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { GroupsService } from "../../groups/groups.service";
import { ENV_BUILD, environment } from "../../../environments/environment";
import { PageTitleEnum } from "../enums/page-title.enum";
import { BehaviorSubject, Subject } from "rxjs";


@Injectable({
  providedIn: "root"
})
/**
 * Shared service to set default title and favicon for the application.
 * Need to refactor this service - code moved from old stemexe 
 */
export class SharedService {
  bannerSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public myDayTabLoaded$: Subject<boolean> = new Subject<boolean>();
  
  constructor(
    private groupsService: GroupsService,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) { }

  // Need to revisit if needed
  // setDefaultTitleAndFavicon(title?: string) {
  //   if (title && title.trim() != "") {
  //     //if title is set explicitly than use it
  //     this.titleService.setTitle(title);
  //   } else if (environment.build == ENV_BUILD.STEMEXE) {
  //     //if it's stemexe build

  //     if (environment.enableGroupsSelection) {
  //       //set default stemxe title if group selection is enabled
  //       this.titleService.setTitle(PageTitleEnum.StemexeTitle);
  //       const appFavicon = this.document.getElementById("appFavicon");
  //       if (appFavicon) {
  //         appFavicon.setAttribute("href", "assets/stemexe-fav.png");
  //       }
  //     } else if (this.groupsService.groupId()) {
  //       let request$ = this.groupsService
  //         .getUserGroupsProfiles([this.groupsService.groupId()])

  //       request$
  //         .subscribe((groupInfo) => {
  //           if (groupInfo.FirstName && groupInfo.FirstName != "") {
  //             this.titleService.setTitle(`${groupInfo.FirstName} | StemeXe`);
  //           } else {
  //             this.titleService.setTitle(PageTitleEnum.StemexeTitle);
  //           }

  //           const smallProfileImageUrl = groupInfo.ProfileImageUrl?.replace('/profileimages/', '/profileimages-small/');

  //           const favicon =
  //             smallProfileImageUrl ?? "assets/stemexe-fav.png";

  //           const appFavicon = this.document.getElementById("appFavicon");
  //           if (appFavicon) {
  //             appFavicon.setAttribute("href", favicon);
  //           }
  //         });
  //     } else {
  //       this.titleService.setTitle(PageTitleEnum.StemexeTitle);
  //     }
  //   } else if (environment.build == ENV_BUILD.EXCEEDERS) {
  //     this.titleService.setTitle(PageTitleEnum.ExceedersTitle);
  //     this.document
  //       ?.getElementById("appFavicon")
  //       ?.setAttribute("href", "assets/exceeders-fav.jpg");
  //   } else {
  //     this.titleService.setTitle(PageTitleEnum.StemexeTitle);
  //     this.document
  //       ?.getElementById("appFavicon")
  //       ?.setAttribute("href", "assets/stemexe-fav.png");
  //   }
  // }

}
